import React from 'react';
import { Edit } from 'react-admin';
import GroupCategorySummary from './GroupCategorySummary';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import SimpleFormWithSave from '../../core/components/form/SimpleFormWithSave';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  fullWidth: {
    width: '100%'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  }
});

const GroupCategoryForm = props => {
  const {
    handleSubmit,
    setGroupCategoryFormProps,
    operation,
    categoryOrSubcategoryIds,
    groupId,
    classes,
    isDisplayAdminCategoriesOn,
    ...operationProps
  } = props;
  if (operation === 'Create') {
    return (
      <CustomSimpleForm
        initialValues={{
          categories: [],
          groups: [],
          categoryOrSubcategoryIds,
          groupId
        }}
        toolbar={null}
        // We override the redux-form name to avoid collision with the react-admin main form
        resource="groupcategories"
        // We override the redux-form onSubmit prop to handle the submission ourselves
        save={handleSubmit}
        className={classes.form}
        variant="standard"
        margin="normal"
      >
        <FormSpy>
          {props => {
            setGroupCategoryFormProps(props);
            return (
              <GroupCategorySummary
                {...props}
                creation={true}
                categoryOrSubcategoryIds={categoryOrSubcategoryIds}
                groupId={groupId}
                variant="standard"
                isDisplayAdminCategoriesOn={isDisplayAdminCategoriesOn}
              />
            );
          }}
        </FormSpy>
      </CustomSimpleForm>
    );
  } else {
    return (
      <Edit {...operationProps} record={{}} className={classes.fullWidth}>
        <SimpleFormWithSave
          initialValues={{ categoryOrSubcategoryIds, groupId }}
          toolbar={null}
          // We override the redux-form name to avoid collision with the react-admin main form
          resource="fundinvestors"
          // We override the redux-form onSubmit prop to handle the submission ourselves
          onSave={handleSubmit}
          variant="standard"
          margin="normal"
        >
          <FormSpy>
            {props => {
              setGroupCategoryFormProps(props);
              return (
                <GroupCategorySummary
                  {...props}
                  categoryOrSubcategoryIds={categoryOrSubcategoryIds}
                  groupId={groupId}
                  variant="standard"
                />
              );
            }}
          </FormSpy>
        </SimpleFormWithSave>
      </Edit>
    );
  }
};

export default withStyles(styles)(GroupCategoryForm);
